import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RoutingTabTitleService } from './shared/service/routing-tab-title/routing-tab-title.service';
import { SeoAlternateLinksService } from '@app/i18n';

import { CookieBarComponent } from './cookie-bar/cookie-bar/cookie-bar.component';
import { HeaderComponent } from './header/header/header.component';
import { FooterComponent } from './footer/footer/footer.component';

@Component({
    selector: 'app-root',
    styleUrls: ['./app.component.scss'],
    templateUrl: './app.component.html',
    imports: [RouterModule, HeaderComponent, FooterComponent, CookieBarComponent],
})
export class AppComponent implements OnInit {
    private routingTabTitleService = inject(RoutingTabTitleService);
    private seoAlternateLinksService = inject(SeoAlternateLinksService);

    // Language is resolved and translations loaded before the first render by
    // provideLanguageInitializer(), so there is no lang detection here anymore.
    ngOnInit(): void {
        this.routingTabTitleService.init();
        this.seoAlternateLinksService.init();
    }
}
